import React from 'react';

export const RedTrash = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99984 4.66699V12.0003C3.99984 12.3539 4.14031 12.6931 4.39036 12.9431C4.64041 13.1932 4.97955 13.3337 5.33317 13.3337H10.6665C11.0201 13.3337 11.3593 13.1932 11.6093 12.9431C11.8594 12.6931 11.9998 12.3539 11.9998 12.0003V4.66699M5.99984 4.66699C5.99984 4.13656 6.21055 3.62785 6.58562 3.25278C6.9607 2.87771 7.4694 2.66699 7.99984 2.66699V2.66699C8.53027 2.66699 9.03898 2.87771 9.41405 3.25278C9.78912 3.62785 9.99984 4.13656 9.99984 4.66699V4.66699H5.99984ZM5.99984 4.66699H9.99984H5.99984ZM5.99984 4.66699H3.99984H5.99984ZM9.99984 4.66699H11.9998H9.99984ZM13.3332 4.66699H11.9998H13.3332ZM2.6665 4.66699H3.99984H2.6665Z"
      stroke="#BF2600"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
